module.exports = __webpack_public_path__ + "static/media/userAssign.6ff21151.svg";